<template>
  <b-form-group
    :id="'group' + id"
    :class="`text-input-group ${requireError ? 'require-field' : ''}`"
    :label-for="id"
    :label="`${$translate(placeholder)} ${required ? '*' : ''}`"
  >
    <b-form-radio-group
      :id="id"
      :ref="id"
      v-model="text"
      :options="options"
      size="lg"
      :disabled="disabled || viewMode"
      :class="`input ${viewMode ? 'viewMode' : ''} ${small ? 'smallMode' : ''}`"
      @change="updateValue"
      @focus="focused = true"
      @blur="focused = false"
    />
  </b-form-group>
</template>
<script>
export default {
  name: 'Radio',
  props: {
    viewMode: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    bottomText: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    options: {
      type: Array,
      default: () => []
    },
    onChange: {
      type: Function,
      default: () => {}
    },
    value: {
      type: [String, Number],
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    tileSize: {
      type: Number,
      default: 14
    },
    updateError: {
      type: Function,
      default: () => {}
    }
  },
  data: function() {
    return {
      text: '',
      focused: false,
      id: '',
    };
  },
  computed: {
    requireError: function() {
      return this.required && !this.text;
    },
    isError: function() {
      const error = this.error || this.requireError;
      this.updateError(error);
      return error;
    }
  },
  watch: {
    value(newVal) {
      this.text = newVal;
    }
  },
  mounted() {
    this.id =
      Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '') + new Date().getTime();
    this.text = this.value;
  },
  methods: {
    setFocus() {
      this.$refs[this.id].$el.focus();
    },
    updateValue(value) {
      this.$emit('input', value);
      this.onChange();
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep  .custom-radio.b-custom-control-lg .custom-control-label {
  padding-left: 0px;
}

::v-deep  .smallMode .custom-radio.b-custom-control-lg .custom-control-label::before {
  width: 16px;
  height: 16px;
  top: 0.55rem;
  background: rgba(197, 208, 222, 0.1);
  border: 1px solid #C5D0DE;
}

::v-deep  .smallMode .custom-radio.b-custom-control-lg .custom-control-label::after {
  width: 10px;
  height: 10px;
  top: 12px;
  left: -27px;
  border-radius: 50%;
  cursor: pointer;
}

::v-deep .custom-radio.b-custom-control-lg .custom-control-label::after {
  width: 14px;
  height: 14px;
  top: 8px;
  left: -27px;
  border-radius: 50%;
  cursor: pointer;
}

::v-deep  .smallMode .custom-radio.b-custom-control-lg .custom-control-label span {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}

::v-deep  .custom-control-input:checked ~ .custom-control-label::before {
  border: 1px solid #2260FF;
}
::v-deep  .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: none;
  background-color: #2260FF;
}

.input-label-focus {
  font-size: 12px !important;
  top: -8px !important;
  line-height: 15px;
}
.input-label-focus-color {
  color: #80bdff !important;
}

.input {
  display: flex;
  flex-wrap: wrap;
}

.input-label-error {
  color: #dc3545 !important;
}

.input-label {
  position: absolute;
  left: 10px;
  color: #80868b;
  top: 6px;
  font-size: 14px;
  background: white;
  padding: 0 5px;
  transition: all 0.2s ease-out;
  z-index: 2;
}

.wrapper {
  display: flex;
}

.text-input-group {
  position: relative;
}

.error-message {
  position: absolute;
  top: 32px;
  color: #dc3545;
  white-space: nowrap;
}

.custom-select:focus {
  color: #495057;
  background-color: #fff;
  border-color: none !important;
  box-shadow: none !important;
  outline: 0;
}

.viewMode {
  background-color: #fff !important;
  color: #495057;
  opacity: 1;
  background: none;
}
.text-input-group.require-field {
  color: #ed3232;
}

::v-deep .custom-control-label {
  color: #212529;
}
</style>
